export const URL_CONFIG = {
  BASE_URL: '',
  APOLLO_URL: process.env.REACT_APP_APOLLO_URL,
};